import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesTypesScreenSchemesConfigureRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-types-screen-schemes-configure',
	path: '/secure/admin/ConfigureIssueTypeScreenScheme.jspa',
};
